
import axios from 'axios'
import env from "./config/env"
//expose axios to global object
window.axios = axios;

window.axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('token')

window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

import Echo from 'laravel-echo';

window.Pusher = require('pusher-js');

window.Echo = new Echo({
    broadcaster: 'reverb',
    key: env.pusherKey || 'S1G4P23',
    wsHost: env.webserviceHost,
    wsPort: env.webservicePort || 443,
    wssPort: env.webservicePort || 443,
    authEndpoint: env.normalURL + 'broadcasting/auth',
    auth: {
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('token'),
        },
    },
    forceTLS: false,
    enabledTransports: ['ws', 'wss'],
});

window.Echo.connector.pusher.connection.bind("connected", () => {
    console.log("Conectado ao WebSocket com sucesso!");
});

window.Echo.connector.pusher.connection.bind("error", (err) => {
    console.error("Erro na conexão WebSocket:", err);
});

window.$ = window.jQuery = require('jquery');
require('bootstrap');
